import {
	Box,
	Button,
	Flex,
	Modal,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	type ModalProps,
} from "@chakra-ui/react";

export type SimpleModalProps = {
	onQuit?: () => void;
	onQuitAndSave?: () => void;
	isDisabled?: boolean;
};

const QuitModal = ({
	isOpen,
	onClose,
	onQuit,
	onQuitAndSave,
	isDisabled = false,
}: ModalProps & SimpleModalProps) => {
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
			<ModalContent maxW={"none"} w={"600px"}>
				<ModalHeader borderBottom="solid 1px #E2E8F0">
					<Flex className="flex items-center justify-center">
						<Box lineHeight="48px">Vous allez quitter sans enregistrer</Box>
					</Flex>
				</ModalHeader>
				<ModalCloseButton onClick={onClose} />
				<ModalFooter borderTop="solid 1px #E2E8F0">
					<Flex w="100%" gap={4}>
						<Button
							w="100%"
							colorScheme={"red"}
							onClick={onQuit}
							disabled={isDisabled}
							className="items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
							style={{
								display: "flex",
								flexDirection: "row",
								gap: "12px",
							}}
						>
							Quitter sans enregistrer
						</Button>
						<Button
							w="100%"
							variant="outline"
							onClick={onQuitAndSave}
							disabled={isDisabled}
							tabIndex={-1}
						>
							Enregistrer en brouillon
						</Button>
					</Flex>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default QuitModal;
